import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import FolderView from '@/components/FolderTree/FolderTree.vue'
import Loader from "@/components/Loader/LoaderView";
export default {
  props: {
    is_public: {
      type: Boolean,
      default: false,
    },
    portal_admin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FolderView,
    Loader
  },
  computed: {
    isReviewer() {
      if (!this.document_approvals || this.document_approvals.length === 0) {
        return false;
      }

      const reviewerIds = new Set(
        this.document_approvals.flatMap(approval => {
          approval.reviewer?.map(r => r.id) || [];

          return approval.reviewer.map(r => {
            return typeof r.id === "object" ? r.id.value || JSON.stringify(r.id) : r.id;
          });
        })
      );


      const found = Array.from(reviewerIds).some(id => {
        return id === parseInt(this.user_id, 10);
      });

      if (found) {
        return true;
      }

      return false;
    }
  },
  mounted() {
    this.user_details = get_user_details();
    this.token_exists = get_token();
    this.user_id = this.get_user_id();
    this.fetch_document_approval_request();
    this.fetch_document_warehouse_folders();
  },
  watch:{
    '$route.params.portal_id'() {
      this.fetch_document_approval_request();
      this.fetch_document_warehouse_folders();
    }
  },
  data() {

    return ({
      user_details: {
        "user_role": '',
        "user_id": null,
      },
      document_approvals: [],
      file: null,
      selectedDocumentIds: [],
      showMoveFolderModal: false,
      members: [],
      fileName: '',
      token_exists: false,
      errors: {

      },
      previewFileUrl: '',
      previewFileType: '',
      previewDocumentUrl: '',
      selectedFolder:null,
      folders:[],
      folderStack: [], // keeps track of navigation history
      currentFolders: [],
      currentFiles:[],
      isLoading: false,
      is_uploading: false,
      loading: true,
      permission_types: [],
      permission_map: {},
      selected_file: {},
      folder_document_permissions: [],
    })
  },

  methods: {
    toggleSelectAll(event) {
    if (event.target.checked) {
      this.selectedDocumentIds = this.currentFiles.map(file => file.id);
    } else {
      this.selectedDocumentIds = [];
    }
  },
  openMoveToFolderModal() {
    this.fetch_document_warehouse_folders();
    $('#move_to_folder_modal').modal('show');
  },
  moveSelectedDocumentsToFolder() {
    if (!this.selectedFolderId || this.selectedDocumentIds.length === 0) return;


    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/batch_move_folder_documents/`,
      method: "POST",
      data: JSON.stringify({
    destination_folder_id: this.selectedFolderId,
    folder_document_ids: this.selectedDocumentIds
  }),
      headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      success: (response) => {
        if (response.status === "success") {
          this.currentFiles = this.currentFiles.filter(file => file.id !== this.selectedDocumentIds);
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Documents moved to folder successfully.',
            showConfirmButton: false,
            timer: 1000
          }).then(() => {
            $('#move_to_folder_modal').modal('hide');
            this.selectedFolderId = null;
            this.selectedDocumentIds = [];
          })
        }
      },
      error: (xhr) => {
        console.error("Error moving documents to folder:", xhr);
      }

    })
  },
    fetch_portal_members(callback) {
        this.isLoading = true;
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
            method: "GET",
            data: { portal_id: this.$route.params.portal_id },
            headers: {
            "Authorization": `Token ${this.getToken()}`,
            "Content-Type": "application/json"
            },
            success: (response) => {

            if (response.status === "success") {
                 this.members = response.data.members;
            }
            if (callback) callback();
            },
            error: (xhr) => {
            if (xhr.status === 403) {
                this.$router.push("/");
                Swal.fire({
                icon: "error",
                title: "Access Denied",
                text: "You are not authorized to be in this portal.",
                showConfirmButton: false,
                timer: 3000
                });
            }
            },
            complete: () => {
            this.isLoading = false;
            }
        });
        },
    getToken() {
      return get_token();
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    fetch_document_warehouse_folders() {
      this.isLoading = true;
      const payload = {
          portal_id: this.$route.params.portal_id,
      }
      const params = new URLSearchParams(payload).toString();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_folder_information/?${params}`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.folders = response.data;
          this.currentFolders = this.folders;
        
          setTimeout(() => {

            this.loading = false;
          }, 1000);
        },
        error: (xhr) => {
          let errorMessage = 'An unexpected error occurred.';
          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            showConfirmButton: false,
            timer: 2000
          });
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
   openFolder(id) {
    this.selectedFolder = id
    },
    fetch_document_approval_request() {
      const payload = {
        filter_values: {
          portal_id: this.$route.params.portal_id,
          status__name__in: ['approved', 'no_approval'],

        }
      }

      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_document_approval/`,
        method: 'POST',
        data: JSON.stringify(payload),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.document_approvals = response.data.document_approvals;

          setTimeout(() => {

            this.loading = false;
          }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handleOpenFolder(folder) {
      this.isLoading = true; 
      if (folder.subfolders && folder.subfolders.length > 0) {
        // If the folder has subfolders, push it to the folder stack and update currentFolders
        this.folderStack.push({ id: folder.id, folder_name: folder.folder_name, subfolders: folder.subfolders });
        this.currentFolders = folder.subfolders;
        this.currentFiles = folder.files || [];
      } else if ((!folder.subfolders || folder.subfolders.length === 0) && folder.files && folder.files.length > 0) {
        // If the folder has files but no subfolders, still allow navigation
        this.folderStack.push({ id: folder.id, folder_name: folder.folder_name, subfolders: [] });
        this.currentFolders = [];
        this.currentFiles = folder.files;
        this.isLoading = false;
      } else {
        // If the folder is empty, update the state and show the "Folder empty" message
        this.folderStack.push({ id: folder.id, folder_name: folder.folder_name, subfolders: [] });
        this.currentFolders = [];
        this.currentFiles = [];
        this.isLoading = false;
      }
    },
    goBack() {
      if (this.folderStack.length > 0) {
        // Remove the last folder from the stack
        this.folderStack.pop();
  
        if (this.folderStack.length > 0) {
          // If there are still folders in the stack, update currentFolders and currentFiles
          const parentFolder = this.folderStack[this.folderStack.length - 1];
          this.currentFolders = parentFolder.subfolders || [];
          this.currentFiles = parentFolder.files || [];
        } else {
          // If no folders are in the stack, reset to the root level
          this.currentFolders = this.folders || [];
          this.currentFiles = []; // Clear files at the root level
        }
      }
    },
    goToFolder(index) {
      if (
        typeof index !== 'number' ||
        !Number.isInteger(index) ||
        index < 0 ||
        !Array.isArray(this.folderStack) ||
        index >= this.folderStack.length
      ) {
        console.warn('Invalid folder index:', index);
        return;
      }
    
      this.folderStack = this.folderStack.slice(0, index + 1);
  
      const selectedFolder = this.folderStack.at(index); 
      this.currentFolders = selectedFolder?.subfolders ?? [];
    },    
    form_date(dateString) {
      return new Date(dateString).toLocaleString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    getFileIcon(fileUrl) {
      if (fileUrl.includes('.pdf')) return 'https://cdn-icons-png.flaticon.com/128/337/337946.png';
      if (fileUrl.includes('.doc') || fileUrl.includes('.docx')) return 'https://cdn-icons-png.flaticon.com/128/337/337932.png';  // Word icon
      if (fileUrl.includes('.xls') || fileUrl.includes('.xlsx')) return 'https://cdn-icons-png.flaticon.com/128/337/337958.png';  // Excel icon
      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png' ;
    },

    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },

    previewDocument(fileObj) {
      if (fileObj && fileObj.file && fileObj.file.s3_url) {
        const fileUrl = fileObj.file.s3_url;
        const fileType = this.getFileType(fileUrl);

        if(fileType === 'word' || fileType === 'excel') {
          this.previewDocumentUrl = 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileUrl);
        } else {
          this.previewDocumentUrl = fileUrl;
        }
        this.previewDocumentType = fileType;
        $("#document_preview_modal").modal("show");
      } else {
        console.error("File object or file URL is missing");
      }
    },

    getFileType(url) {
  if (typeof url !== 'string') return 'unknown';

  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname; // Gets the part after the domain
    const filename = pathname.split('/').pop(); // Gets "Workstreams -Sprint 13 (3).docx"
    const extension = filename.split('.').pop().toLowerCase();

    if (extension === 'pdf') return 'pdf';
    if (['doc', 'docx'].includes(extension)) return 'word';
    if (['xls', 'xlsx'].includes(extension)) return 'excel';
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) return 'image';

    return 'unknown';
  } catch (error) {
    console.error("Invalid URL in getFileType:", error);
    return 'unknown';
  }
},
    create_folder(){
      this.isCreatingFolder = true;
      const parentFolderId = this.folderStack.length > 0 ? this.folderStack[this.folderStack.length - 1].id : null;

      // Prepare the payload for the new folder
      const payload = {
        folder_name: this.folder_name,
        is_parent:true,
        portal_id: this.$route.params.portal_id,
      };

      if (parentFolderId !== null) {
        payload.parent_folder_id = parentFolderId;
        payload.is_parent=false
      }
    
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_folder_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (data) => {
          if (data.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Folder created successfully.',
              showConfirmButton: false,
              timer: 1000
            }).then(() => {
              Swal.close();
              const newFolder = {
                id: data.folder_data.id, // Assuming the API returns the new folder's ID
                folder_name: this.folder_name,
                date_created: data.folder_data.date_created,
                subfolders: [],
                files: [],
              };
              this.currentFolders.push(newFolder);
    
              // Clear the folder name input
              this.folder_name = '';

              
            });
          }
        },
        error: (xhr) => {
          let errorMessage = 'An unexpected error occurred.';
          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            showConfirmButton: false,
            timer: 2000
          });
        },
        complete: () => {
          this.isLoading = false;
          this.isCreatingFolder = false; // Stop loader
        }
      });
    },
    delete_folder_document(folder_document_id) {
      Swal.fire({
              title: 'Are you sure?',
              text: 'You won\'t be able to revert this!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.isConfirmed) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_folder_document/`,
        method: 'DELETE',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          folder_document_id: folder_document_id
        }),
        success: (data) => {
          if (data.status === "success") {
            this.currentFiles = this.currentFiles.filter(file => file.id !== folder_document_id);
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Document deleted successfully.',
              showConfirmButton: false,
              timer: 1000
            }).then(() => {
              Swal.close();
              
            });
          }
        },
        error: (xhr) => {
          let errorMessage = 'An unexpected error occurred.';
          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            showConfirmButton: false,
            timer: 2000
          });
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
    });
    },
    navigateToFolder(folderId) {
      this.$emit('navigate', folderId);
    },
    triggerFileUpload() {
      this.$refs.warehouse_file.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.is_uploading = true;
        const fileName = file.name; // Extract the document name
        const formData = new FormData();
        formData.append('file', file);
        formData.append('portal_id', this.$route.params.portal_id);
        formData.append('file_name',fileName);
  
        // If inside a folder, pass the parent folder ID
        const parentFolderId = this.folderStack.length > 0 ? this.folderStack[this.folderStack.length - 1].id : null;
        if (parentFolderId) {
          formData.append('folder_id', parentFolderId);
        }
  
        // Make an API call to upload the document
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_folder_cocument_api/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
          },
          data: formData,
          processData: false,
          contentType: false,
          success: (data) => {
            if (data.status === 'success') {
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Document uploaded successfully.',
                showConfirmButton: false,
                timer: 1000,
              }).then(() => {
                Swal.close();
  
                const newFile = {
                  id: data.document_folder_data.id, 
                  file: {
                    name: fileName,
                    s3_url: data.document_folder_data.file.s3_url, 
                    date: data.document_folder_data.file.date, 
                  }
                };
                this.currentFiles.push(newFile);
               
              });
            }
          },
          error: (xhr) => {
          let errorMessage = 'An unexpected error occurred.';
          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            showConfirmButton: false,
            timer: 2000
          });
        },
          complete: () => {
            this.is_uploading = false;
            if (this.$refs.warehouse_file) {
              this.$refs.warehouse_file.value = '';
            }
          },
        });
      }
    },
    remove_folder(folderId) {
    this.currentFolders = this.currentFolders.filter(f => f.id !== folderId);
  },

    get_permissions_types() {
      this.token_exists = get_token();

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_permissions/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.permission_types = response.permission_types;

          this.permission_types.forEach(perm => {
            this.permission_map[perm.name.toLowerCase()] = perm.id;
          });
        },
        complete: () => {
          this.isLoading = false;
        },
      });

    },

    get_folder_document_permissions(folder_document_id) {
      this.token_exists = get_token();

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_folder_document_permissions/?folder_document_id=${folder_document_id}`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {

          const raw_permissions = response.folder_document_permissions;

        const portal_member = this.members
          const grouped = new Map();
          raw_permissions.forEach(perm => {
            const user_id = perm.portal_access.id
            const permission_name = perm.permission.name.toLowerCase();

            if(!['view', 'download', 'delete', 'upload'].includes(permission_name)) return;

            if (!grouped.has(user_id)) {
              grouped.set(user_id, {
                portal_access: perm.portal_access,
                view: permission_name === 'view',
                download: permission_name === 'download',
                delete: permission_name === 'delete',
                upload: permission_name === 'upload',

                is_owner: perm.is_owner || false
              })
            }

            const user_permissions = grouped.get(user_id);
            user_permissions.set(permission_name, true);
          });

          const final_permissions = portal_member.map(member => {
            return grouped.get(member.id) || {
              portal_access: member,
              view: false,
              download: false,
              upload: false,
              delete: false,
              is_owner: false };
          })
          this.folder_document_permissions = final_permissions;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
  manage_document_permissions(folder_document_id) {
    const file = this.currentFiles.find(file => file.id === folder_document_id);

    if (!file) {
      console.error('File not found');
      return;
    }

    const file_name = this.getFileName(file.file.name);

    this.selected_file = {
      ...file,
      name: file_name
    }
    this.fetch_portal_members(() => {
      this.get_folder_document_permissions(folder_document_id);

      $('#manage_document_permissions_modal').modal('show');
    })


  },

    save_folder_document_permissions() {
      this.folder_document_permissions.forEach(user => {
        if (user.is_owner) return;
        const permission_type_ids = [];

        if (user.view) permission_type_ids.push(this.permission_map.view);
        if (user.upload) permission_type_ids.push(this.permission_map.upload);
        if (user.download) permission_type_ids.push(this.permission_map.download);
        if (user.delete) permission_type_ids.push(this.permission_map.delete);

        if (permission_type_ids.length === 0) return; // skip if no permissions

        const payload = {
          folder_document_id: this.selected_file.id || this.selected_file,
          portal_member_ids: [user.portal_access.id],
          permission_type_ids: permission_type_ids,
        };

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/set_folder_document_permissions/`,
          method: "POST",
          headers: {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(payload),
          success: () => {
            Swal.fire("Success", "Permissions Set Successfully", "success");
      $('#manage_document_permissions_modal').modal('hide');
          },
          error: (xhr) => {
            console.error(`Failed to save for ${user.portal_access.email}`, xhr.responseJSON);
          }
        });
      });


    }


  }
};
